export default __webpack_public_path__ + "static/product-novelty-badge-a4afd022d377501f975e6c3a85641c96.png";